namespace HA.Core.HTML {
    //noinspection TsLint
    export class FlexItem extends Container {
        /**
         *
         * @param data
         */
        protected initialize(data: any) {
            super.initialize(data);
           // this.addClass("fi");
        }
    }
}
